import { Box, Typography, useMediaQuery } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import ExternalLink from 'Components/_common/ExternalLink'
import React from 'react'
import FAIcon from 'Theme/FAIcon'
import { FA_ICONS } from 'Theme/font-awesome-icon-constants'
import Skeleton from 'Theme/Skeleton'

import { BREAKPOINT_MIN_MD } from '../../../Theme/stylesUtil'

const Flag = React.lazy(() => import(/* webpackChunkName: "react-world-flags" */ 'react-world-flags'))

const useStyles = makeStyles((theme) => ({
  flag: {
    width: 18,
    height: 12,
    marginRight: theme.spacing(1),
    borderRadius: theme.shape.borderRadius * 0.375,
  },
  biography: {
    wordBreak: 'break-all',
  },
}))

export const ProfileSocialIcons = ({ className, profile, isUserFetched, user, fullWidth = false }) => {
  const isBiggerThanMDScreen = useMediaQuery(BREAKPOINT_MIN_MD)
  const width = fullWidth ? '100%' : isBiggerThanMDScreen ? 324 : 200
  const classes = useStyles()
  const xboxGamerTagParam = profile?.link_xbox && profile?.link_xbox.split('?')[1]
  const xboxGamerTag = new URLSearchParams(xboxGamerTagParam).get('gamertag')

  return (
    <Box
      width={width}
      marginLeft={3}
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <Box display="flex">
        {isUserFetched ? (
          <Typography
            variant="h2"
            color="text.primary"
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: '300px',
            }}
          >
            {user.login}
          </Typography>
        ) : (
          <Skeleton width={100} />
        )}
      </Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        width={240}
        marginTop={1}
      >
        <Box
          display="flex"
          alignItems="baseline"
        >
          {profile?.country_id?.iso && (
            <Flag
              code={profile?.country_id?.iso}
              className={classes.flag}
            />
          )}
          <Box>
            <Typography
              variant="body2bold"
              color="text.tertiary"
            >
              {user?.firstName} {user?.secondName}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        marginTop={1}
        className={classes.biography}
        sx={{ width }}
      >
        <Typography
          variant="body2bold"
          color="text.tertiary"
          sx={{ wordBreak: 'normal' }}
        >
          {profile?.biography}
        </Typography>
      </Box>
      <Box
        className={className}
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          marginTop: '8px',
          gap: '24px',
          alignItems: 'center',
        }}
      >
        {profile?.link_xbox && (
          <Box
            display="flex"
            alignItems="center"
            gap={1}
          >
            <ExternalLink
              to={profile.link_xbox}
              style={{ margin: 0 }}
            >
              <FAIcon
                iconClassName={FA_ICONS.XBOX}
                fontSize={18}
                color="text.tertiary"
              />
            </ExternalLink>
            <Typography sx={{ textTransform: 'uppercase', fontWeight: 800, fontSize: 10 }}>{xboxGamerTag}</Typography>
          </Box>
        )}
        {profile?.link_youtube && (
          <ExternalLink to={profile.link_youtube}>
            <FAIcon
              iconClassName={FA_ICONS.YOUTUBE}
              fontSize={18}
              color="text.tertiary"
            />
          </ExternalLink>
        )}
        {profile?.link_twitch && (
          <ExternalLink to={profile.link_twitch}>
            <FAIcon
              iconClassName={FA_ICONS.TWITCH}
              fontSize={18}
              color="text.tertiary"
            />
          </ExternalLink>
        )}
        {profile?.link_discord && (
          <ExternalLink to={profile.link_discord}>
            <FAIcon
              iconClassName={FA_ICONS.DISCORD}
              fontSize={18}
              color="text.tertiary"
            />
          </ExternalLink>
        )}
        {profile?.link_twitter && (
          <ExternalLink to={profile.link_twitter}>
            <FAIcon
              iconClassName={FA_ICONS.TWITTER}
              fontSize={18}
              color="text.tertiary"
            />
          </ExternalLink>
        )}
        {profile?.link_instagram && (
          <ExternalLink to={profile.link_instagram}>
            <FAIcon
              iconClassName={FA_ICONS.INSTAGRAM}
              fontSize={18}
              color="text.tertiary"
            />
          </ExternalLink>
        )}
        {profile?.link_website && (
          <ExternalLink to={profile.link_website}>
            <FAIcon
              iconClassName={FA_ICONS.GLOBE}
              fontSize={18}
              color="text.tertiary"
            />
          </ExternalLink>
        )}
      </Box>
    </Box>
  )
}
